import { ChevronRight, Home } from "lucide-react";
import { trackEvent } from "@/lib/analytics";

export interface BreadcrumbItem {
  name: string;
  path: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
  className?: string;
}

const Breadcrumbs = ({ items, className }: BreadcrumbsProps) => {
  if (items.length === 0) return null;

  const handleClick = (item: BreadcrumbItem, position: number) => () =>
    trackEvent("breadcrumb_click", {
      target_path: item.path,
      target_name: item.name,
      position,
      depth: items.length,
    });

  return (
    <nav
      aria-label="Breadcrumb"
      className={`text-mono text-xs uppercase tracking-wider text-muted-foreground ${className ?? ""}`.trim()}
    >
      <ol className="flex flex-wrap items-center gap-1.5">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={item.path} className="flex items-center gap-1.5">
              {index === 0 ? (
                <a
                  href={item.path}
                  className="flex items-center gap-1 transition-colors hover:text-primary"
                  onClick={handleClick(item, index + 1)}
                >
                  <Home className="h-3 w-3" />
                  <span className="sr-only sm:not-sr-only">{item.name}</span>
                </a>
              ) : isLast ? (
                <span aria-current="page" className="text-foreground">
                  {item.name}
                </span>
              ) : (
                <a
                  href={item.path}
                  className="transition-colors hover:text-primary"
                  onClick={handleClick(item, index + 1)}
                >
                  {item.name}
                </a>
              )}
              {!isLast && <ChevronRight className="h-3 w-3" aria-hidden="true" />}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumbs;
